import { useEffect, useState } from "react";
import { DescriptionTextType } from "../../static/types/commonTypes/descriptionTextType"
import FieldDescription from "../tools/FieldDescription";

type DescriptionTextProps = {
    checked: boolean;
    labelDescription: string;
    descriptionText: DescriptionTextType;
    updateDescriptionText: (descriptionText: Partial<DescriptionTextType>) => void;
    onValidationDescriptionText: (isValid: boolean) => void;
    fieldDescription: string;
    placeholder?: string;
    defaultValue?: string;
};

export default function DescriptionTextComponent({
    checked,
    labelDescription,
    descriptionText,
    updateDescriptionText,
    onValidationDescriptionText,
    fieldDescription,
    placeholder,
    defaultValue = ""
}: DescriptionTextProps) {
    const [errors, setErrors] = useState<{ object?: string }>({});

    const validateInput = (value: string) => {
        const newErrors: { object?: string } = {};
        if (!value.trim()) {
            newErrors.object = "Ce champ est requis";
        }

        setErrors(newErrors);
        onValidationDescriptionText(Object.keys(newErrors).length === 0);
    };
    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const { value } = event.target;

        updateDescriptionText({ descriptionText: value } as Partial<DescriptionTextType>);

        validateInput(value);
    };
    useEffect(() => {
        validateInput(descriptionText.descriptionText || defaultValue);
    }, [descriptionText.descriptionText]);

    return (
        <div className="mt-3">
            <div className="mb-3 row position-relative">
                <label htmlFor="object" className="col-sm-2 col-form-label">
                    {labelDescription} <strong className="text-danger">*</strong>
                </label>

                <div className="col-sm-10">
                    <textarea
                        className={`description-input form-control ${checked && errors.object ? "is-invalid" : ""}`}
                        id="object"
                        value={descriptionText.descriptionText || defaultValue}
                        onChange={handleChange}
                        placeholder={placeholder}
                    />

                    <FieldDescription description={fieldDescription} />

                    {checked && errors.object && (
                        <div className="invalid-feedback">{errors.object}</div>
                    )}
                </div>
            </div>
        </div>
    );
}
